module.exports = __webpack_public_path__ + "img/IOTA-alt.e34444e8.svg";